import { OTPInput as SharedOTPInput } from "@circle-react/components/shared/Otp/OtpInput";
import { useMemo } from "react";

interface OTPInputProps {
  disabled?: boolean;
  error?: boolean;
  onComplete?: (otp: string) => void;
  onValueChange?: (otp: string) => void;
}

export const OTPInput = ({
  onComplete,
  onValueChange,
  disabled = false,
  error = false,
}: OTPInputProps) => {
  const inputClassName = useMemo(() => {
    const baseClassName =
      "h-12 w-12 rounded-lg border text-center text-base font-medium leading-6 outline-none transition-all duration-150 focus:outline-none focus:ring-0 sm:h-14 sm:w-14 sm:text-lg sm:leading-7";

    if (disabled) {
      return `${baseClassName} cursor-not-allowed border-tertiary bg-secondary text-disabled`;
    }

    if (error) {
      return `${baseClassName} border-feedback-error bg-primary text-darkest focus:border-feedback-error focus:shadow-[0_0_0_2px_rgba(220,38,38,0.2)]`;
    }

    return `${baseClassName} border-primary bg-primary text-darkest focus:border-light`;
  }, [disabled, error]);

  return (
    <SharedOTPInput
      onComplete={onComplete}
      onValueChange={onValueChange}
      disabled={disabled}
      error={error}
      inputClassName={inputClassName}
      containerClassName="flex gap-[.65rem] sm:gap-[1.9rem]"
      autoFocus={!disabled}
    />
  );
};
